//ask about updatestate an "promotions" from this.state

export const refreshAppliedTargetOffer = ({callback, updateState, applyFilters, promotions, targetedOfferApplied, targetedOfferSelected }) => {
   
    const preTargetedOfferApplied = targetedOfferApplied;
    const preTargetedOfferSelected = targetedOfferSelected;      
    const hadOffer = Object.keys(preTargetedOfferSelected).length > 0 ;
    updateState(    
        {
          targetedOfferApplied: targetedOfferSelected,
          targetedofferValidated: false,
          targetedOffersDisabledMessage: {},       
          promotions : hadOffer ? { valid: false } :  promotions   
        },
        () => {
          if (callback) {
            callback(preTargetedOfferApplied, preTargetedOfferSelected);
          }
          applyFilters();
        },
    );
  };